import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=60b438a8&"
import script from "./ContextMenu.vue?vue&type=script&lang=ts&"
export * from "./ContextMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b438a8')) {
      api.createRecord('60b438a8', component.options)
    } else {
      api.reload('60b438a8', component.options)
    }
    module.hot.accept("./ContextMenu.vue?vue&type=template&id=60b438a8&", function () {
      api.rerender('60b438a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/overlays/ContextMenu.vue"
export default component.exports